export default {
  MAPBOX_TOKEN: 'pk.eyJ1IjoiamZpZnQiLCJhIjoiY2tpczVld3ZmMDFsazJybmttNHpkcG9hdyJ9.9woTr24Ikq2duK-peKinyw'
};

